<template>
  <div class="trackingProgress">
  <div class="progress" :style="{ width: computedPercentage}"></div>
  <div class="orderView">
    <div class="bar"></div>
    <div class="circleWrap">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    transDataSet: {
      progressNum: {
        type: String
      },
      chapterNum: {
        type: Number
      }
    }
  },
  data () {
    return {
      percentage: this.transDataSet.progressNum,
      chapter: this.transDataSet.chapterNum
    }
  },
  mounted () {
    this.findChapter()
  },
  computed: {
    computedPercentage: function () {
      return this.percentage
    }
  },
  methods: {
    findChapter () {
      console.log('퍼센테이지', this.percentage)
      console.log('챕터', this.chapter)
      if (this.chapter === 1) {
        document.querySelector('.circleWrap').childNodes[0].classList.add('active')
      } else if (this.chapter === 2) {
        document.querySelector('.circleWrap').childNodes[1].classList.add('active')
      } else if (this.chapter === 3) {
        document.querySelector('.circleWrap').childNodes[2].classList.add('active')
      } else if (this.chapter === 4) {
        document.querySelector('.circleWrap').childNodes[3].classList.add('active')
      } else {
        console.log('오류')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .trackingProgress {
    position: absolute;
    top: 47px;
    left: 0;
    width: 100%;
  .progress {
    width:25%;
    background:#ff6565;
    height:4px;
    transition: .5s;
  &.secondStep {
     width:50%;
   }
  &.thirdStep {
     width:75%;
   }
  &.done {
     width:100%;
   }
  }
  .orderView {
    position: relative;
    display: flex;
    align-items: center;
    width: 65px;
    margin: 15px auto 0;
    height: 30px;
  .bar {
    width: 65px;
    height: 1px;
    background: #fff;
  }
  .circleWrap {
    display: flex;
    height: 30px;
    align-items: center;
    justify-content: space-between;
    width: 82px;
    position: absolute;
  span {
    width:8px;
    height:8px;
    border-radius:50%;
    overflow: hidden;
    background:#fff;
    position:relative;
  &.active {
    width:14px;
    height:14px;
     background:#ff6565;
     color:#fff;
   }
  }
  }
  }
  }
</style>
